import type { ReploComponentIssue } from "@v1/types/component-issues";

import * as React from "react";

import { Info } from "lucide-react";

const RightBarIssues: React.FC<{
  issues: ReploComponentIssue[];
  endEnhancer?: (issue: ReploComponentIssue) => React.ReactNode;
}> = ({ issues, endEnhancer }) => {
  return (
    <ul className="flex flex-col gap-2">
      {issues.map((issue, index) => (
        <li
          key={index}
          className="bg-rose-soft text-rose flex gap-2 rounded-sm p-2 text-xs"
        >
          <Info size={16} className="shrink-0" />
          <div className="flex flex-col">
            {issue.message}
            {endEnhancer?.(issue)}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default RightBarIssues;
